export const SyncStatus = {
  Idle: 'idle',
  Syncing: 'syncing',
  Error: 'error',
  Stale: 'stale',
} as const;

export type SyncStatus = (typeof SyncStatus)[keyof typeof SyncStatus];
